import React, { useEffect, useState } from "react";

export interface PropertiesProps {
  id: string;
  name: string;
  description: string;
  category: string;
  type:string;
  location: string;
  price: string;
  bed: string;
  bath: string;
  sqft: string;
  imgs: string[];
  featured:string
  sold:string
}

const useProperties = () => {
  const [properties, setProperties] = useState<PropertiesProps[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const localData = localStorage.getItem("akjodem_properties");
  
    // Load cached data immediately
    if (localData) {
      try {
        const parsedData = JSON.parse(localData);
        setProperties(parsedData);
      } catch (err) {
        console.error("Error parsing localStorage data:", err);
        localStorage.removeItem("akjodem_properties");
      }
    }
  
    // Fetch fresh data regardless
    fetch("https://akjodem.com/getProperty.php")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch properties: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          const processedProperties: PropertiesProps[] = data.properties.map((property: any) => ({
            ...property,
            imgs: property.imgs ? property.imgs.split(",") : [],
          }));
  
          setProperties(processedProperties);
          localStorage.setItem("akjodem_properties", JSON.stringify(processedProperties));
        } else {
          setError(data.message || "No properties found");
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  

  return { properties, loading, error };
};

export default useProperties;
